import type { App } from 'vue'
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 // 1 minute
    }
  }
})

export const setupVueQuery = (app: App<Element>) => {
  app.use(VueQueryPlugin, {
    queryClient
  })
}
